import { render } from "./ShowContractTypePopUp.vue?vue&type=template&id=481d190e&scoped=true"
import script from "./ShowContractTypePopUp.vue?vue&type=script&lang=js"
export * from "./ShowContractTypePopUp.vue?vue&type=script&lang=js"

import "./ShowContractTypePopUp.vue?vue&type=style&index=0&id=481d190e&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481d190e"]])

export default __exports__